export default __webpack_public_path__ + "atomic/_patterns/02-molecules/calculate-myseed/_calculate-myseed.twig";